import { publicUserGQL, authenticatedUserGQL } from './graphql/user';
import { publicLOVGQL } from './graphql/lov';
import { publicSwapGQL, authenticatedSwapGQL } from './graphql/swap';
import {
  publicMembershipGQL,
  authenticatedMembershipGQL,
} from './graphql/membership';

export const publicURL = `${process.env.REACT_APP_API_URL}/graphql`;
export const authenticatedURL = `${process.env.REACT_APP_API_URL}/member/graphql`;

export const publicGQL = {
  ...publicLOVGQL,
  ...publicUserGQL,
  ...publicSwapGQL,
  ...publicMembershipGQL,
};

export const authenticatedGQL = {
  ...authenticatedUserGQL,
  ...authenticatedSwapGQL,
  ...authenticatedMembershipGQL,
};

export { configureStubs } from './utilities';
